exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".size {\n  width: 100%;\n  height: 100%;\n}\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n#app {\n  width: 100%;\n  height: 100%;\n}\n.environment-banner {\n  margin-top: 15px;\n  margin-right: 220px;\n  /* 设置元素右侧的外边距为20像素 */\n}\n", ""]);

// exports
